import { getAdminAxiosInstance } from "../../../../api/Admin";

/**
 * Create and update share one entry point, as the plan form does - the service routes on the
 * presence of offer_id. What an *active* offer will accept is decided on the cart service,
 * where the offer's status is known: more seats and a later window end, nothing else.
 */
export const createAndUpdateCorporateOffer = async (params) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.post(`/corporate-offer/create`, params);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
